import { useEffect } from "react";
import { useSiteSettings } from "./cms";

/**
 * Keeps document.title (and the meta description) in sync with the live site
 * settings, so the static index.html fallback gets replaced once React mounts
 * and stays correct across client-side navigations. The authoritative,
 * crawler-facing meta is injected server-side (server/seo.ts); this hook
 * mirrors it for the in-browser experience.
 */
export function useDocumentTitle(pageTitle?: string) {
  const { brand, seo, home } = useSiteSettings();
  useEffect(() => {
    if (typeof document === "undefined") return;
    const base = brand.name || "Ingatlan Site";
    const autoTitle = seo?.metaTitle?.trim()
      ? seo.metaTitle.trim()
      : `${base} — ${brand.tagline}`;
    document.title = pageTitle ? `${pageTitle} — ${base}` : autoTitle;

    const desc =
      seo?.metaDescription?.trim() ||
      home?.heroSubtitle?.trim() ||
      brand.tagline ||
      base;
    let tag = document.querySelector<HTMLMetaElement>(
      'meta[name="description"]',
    );
    if (!tag) {
      tag = document.createElement("meta");
      tag.setAttribute("name", "description");
      document.head.appendChild(tag);
    }
    tag.setAttribute("content", desc);
  }, [
    brand.name,
    brand.tagline,
    seo?.metaTitle,
    seo?.metaDescription,
    home?.heroSubtitle,
    pageTitle,
  ]);
}
